import React, { useEffect, useState } from "react";
import AnalyticsChart from "../../components/chart";
import { getNumberOfInstalls } from "./analytics.service";
import DownloadIcon from "../../Assets/DownloadIcon.svg";

const Installs = ({ app }) => {

    const [appData, setAppData] = useState();
    const [totalInstalls, setTotalInstalls] = useState();

    const modifyAppInstallData = (data) => {
        let temp = data?.map((item) => {
            let dateArr = item.date.replace(/\-/g, ',').split(',')
            return {
                x: Date.UTC(Number(dateArr[0]), Number(dateArr[1])-1, Number(dateArr[2])),
                y: item.data
            }
        })
        setAppData(temp)
    }

    useEffect(async () => {
        const res = await getNumberOfInstalls("numberOfInstalls", app?.id, app?.platform);
        modifyAppInstallData(res.data.data?.groupBy);
        setTotalInstalls(res.data.data?.totalAppsInstalls);
    }, []);

    return (
        <>
            <div className="font-bold font-size-14">Installs by user</div>
            {(totalInstalls) !== 0 ? (<><span className="pt-6 font-size-24 mlc-6">{totalInstalls}</span>
                <div className="highcharts-container mtc-12">
                    <AnalyticsChart graphData={appData} graphType="spline" />
                </div>
            </>) : (<><div className="z-index-1">
                <img
                    className="download-icon"
                    src={DownloadIcon}
                    alt=""
                />
            </div><span className="text-gray font-size-50 font-bold">NA</span></>)}
        </>
    )
}

export default Installs;